import { render, staticRenderFns } from "./KeywordTrendChart.vue?vue&type=template&id=39c73864&scoped=true&"
import script from "./KeywordTrendChart.vue?vue&type=script&lang=js&"
export * from "./KeywordTrendChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c73864",
  null
  
)

export default component.exports